import React from 'react';
import './dots.scss';
const Dots = () => {
    return (React.createElement("div", { className: "dots" },
        React.createElement("span", null, "."),
        React.createElement("span", null, "."),
        React.createElement("span", null, ".")));
};
export default Dots;
